import { useState } from 'react';

const useDataRepresentationEvent = ({mapRef, onClickIn, onClickOut}) => {
  const [hoverElement, setHoverElement] = useState(null)
  const [clickElement, setClickElement] = useState(null)
  const [source, setSource] = useState(null)
  const getFirstFeature = (event) => (event.features && event.features[0])
  const getMap = () => (mapRef.current.getMap())
  const setLayerFeatureState = (event, node, feature, value) => {
    getMap().setFeatureState(
      { source: getFirstFeature(event)?.source || source, id: node.id },
      { [feature]: value }
    );
  }
  const onClick = (e) => {
    const feature = getFirstFeature(e)
    if ( clickElement ) {
      setLayerFeatureState(e, clickElement, 'selected', false)
    }
    if (feature && feature.properties) {
      onClickIn(feature, e)
      setClickElement(feature)
      setLayerFeatureState(e, feature, 'selected', true)
    } else {
      setClickElement(null)
      onClickOut()
    }
  }
  const onMouseEnter = (e) => {
    const feature = getFirstFeature(e)
    setSource(getFirstFeature(e).source)
    if (feature) {
      setHoverElement(feature)
      setLayerFeatureState(e, feature, 'hover', true)
    }
  }
  const onMouseLeave = (e) => {
    if (hoverElement) {
      setLayerFeatureState(e, hoverElement, 'hover', false)
      setHoverElement(null)
    }
  }

  return { onClick, onMouseEnter, onMouseLeave }
}

export default useDataRepresentationEvent